module.exports = __webpack_public_path__ + "static/media/quote.277f82e1.svg";